import { useSelector } from 'react-redux';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { getUserIdFromAuth } from '../selectors/AuthSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkingHours = () => {
  const userId = useSelector(getUserIdFromAuth);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.workingHours.label"
    }),
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.workingHours.description"
    }),
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsx(Link, {
      href: `/settings/${PortalIdParser.get()}/users/user/${userId}?tab=preferencesTab&subtab=workingHours`,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.workingHours.linkLabel"
      })
    })
  });
};
export default WorkingHours;